// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import Meta from 'vue-meta'
import router from './router'
import VeeValidate from 'vee-validate'
import BootstrapVue from 'bootstrap-vue'
import Slick from 'vue-slick'
// import firebase from 'firebase';
import VueLocalStorage from 'vue-localstorage'
import VueCookies from 'vue-cookies';
import GSignInButton from 'vue-google-signin-button'
import FBSignInButton from 'vue-facebook-signin-button'
//import VueTelInput from 'vue-tel-input'
import initi18n from "@/plugins/i18n";


import languageData from '@/languageData';
import languageDataTicketak from '@/languageDataTicketak';
import {
  LanguageService,
  CountryService
} from '@/services/storage.service'
import {
  PROJECT
} from '@/helper/constant.js'
import ReadMore from 'vue-read-more';
import VueClipboard from 'vue-clipboard2'
import Toasted from 'vue-toasted';
import browserDetect from "vue-browser-detect-plugin";

// import VueTagManager from "vue-tag-manager"
import VueGtm from 'vue-gtm';

//import Zendesk from '@dansmaculotte/vue-zendesk'

import VueLazyload from 'vue-lazyload'
//LOADER COMPONENT

//Aos Package Animation

import AOS from 'aos'
import 'aos/dist/aos.css'

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

// import { library } from '@fortawesome/fontawesome-svg-core'
// import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import CryptoJS from 'crypto-js'

import Multiselect from 'vue-multiselect'


//import 'vue-tel-input/dist/vue-tel-input.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'slick-carousel/slick/slick.css'
import './assets/css/pratik.css'
import './assets/css/slick-theme.css'
import './assets/css/style.css'
import './assets/css/style-myticketi.css'
import './assets/css/new-style.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import Vuex from 'vuex'
import store from './store'

import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.use(Vuex)
// library.add(fas, fab)

// Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('slick', Slick);
Vue.use(ReadMore);
//Vue.use(VueTelInput)
// Vue.use(VeeValidate)
Vue.use(GSignInButton)
Vue.use(FBSignInButton)
Vue.use(Meta)
Vue.use(BootstrapVue)
Vue.use(Loading)
Vue.use(VueLocalStorage)
//VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(Toasted)
Vue.use(browserDetect);
Vue.use(VueCookies);
Vue.component('multiselect', Multiselect);




VueCookies.config('30d');

// Vue.use(VueTagManager, {
//   gtmId: PROJECT == 'ticketak' ? 'GTM-K54WBC7' : 'GTM-KL99P29'
// })

Vue.use(VueGtm, {
  //id: PROJECT == 'ticketak' ? 'GTM-P3GVKDD' : 'GTM-TKXCNJF',
});


Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: PROJECT == 'ticketak' ? '/static/img/Cineco-Logo.png' : '/static/Cineco-Logo.png',
  loading: PROJECT == 'ticketak' ? '/static/img/Cineco-Logo.png' : '/static/Cineco-Logo.png',
  attempt: 1,
})

// Vue.use(Zendesk, {
//   key: '0fa8096b-11c0-45f1-9dfe-e82062b79b75',
//   disabled: true,
//   hideOnLoad: false,
//   settings: {
//     webWidget: {
//       color: {
//         theme: '#b70100'
//       }
//     }
//   }
// })

Vue.config.productionTip = false


// VeeValidate.Validator.updateDictionary(dictionary);
Vue.use(VeeValidate);
// Validator.localize('en', dict);

// const config = {
//   apiKey: "AIzaSyBI5jP8rf8goxv9d67XwQnI7VY6SccgGpg",
//   authDomain: "wanasatime-91ac5.firebaseapp.com",
//   projectId: "wanasatime-91ac5",
//   storageBucket: "wanasatime-91ac5.appspot.com",
//   messagingSenderId: "715055681361",
//   appId: "1:715055681361:web:fb658edaf3716770c40d70",
//   measurementId: "G-ENG5XF8QMM",
// }

// firebase.initializeApp(config);
// const messaging = firebase.messaging();

// messaging.setBackgroundMessageHandler(function (payload) {
//   console.log('[firebase-messaging-sw.js] Received background message ', payload);
//   // Customize notification here
//   var notificationTitle = 'Background Message Title';
//   var notificationOptions = {
//     body: 'Background Message body.',
//     icon: '/firebase-logo.png'
//   };

//   return self.registration.showNotification(notificationTitle,
//     notificationOptions);
// });

// function showNotificationPermission() {
//   messaging.requestPermission()
//     .then(() => {
//       console.log('Notification permission granted.')
//       // Get Token
//       messaging.getToken().then((token) => {
//         console.log('token', token)
//       })
//     })
//     .catch((err) => {
//       console.log('Unable to get permission to notify. ', err)
//     })
// }

// showNotificationPermission();

// Created the Event Bus for the call parent function
export const EventBus = new Vue()
let langToken = LanguageService.getLanguage() || {
  lang: 'en',
  lang_id: 2
};
var secretKey = 'HereIsTheMySecretKey_LOL'
let country = CountryService.getCountry();

console.log('PROJECT :', PROJECT);
let ActiveColor = (PROJECT == 'ticketak') ? '#e5007d' : '#b70100';
let countryName = country && country['CountryName'].toLowerCase() ? country['CountryName'].toLowerCase() : 'uae';
Vue.mixin({
  data: function () {
    return {
      data_loading: false,
      project: PROJECT,
      allLanguageData: (PROJECT == 'ticketak') ? languageDataTicketak[langToken['lang']] || 'en' : languageData[langToken['lang']] || 'en',
      countryName: countryName,
      LOADING: null,
      ActiveColor: ActiveColor,
      secureStore: {
        set: function (key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
          window.localStorage.setItem(key, setEncryptedData);
        },
        get: function (key) {
          let getEncryptedData = window.localStorage.getItem(key);
          if (!_.isNull(getEncryptedData))
            return JSON.parse(CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(CryptoJS.enc.Utf8))
          return null;
        },
        remove: function (key) {
          window.localStorage.removeItem(key);
        }
      },
      sessionStore: {
        set: function (key, value) {
          let setEncryptedData = CryptoJS.AES.encrypt(JSON.stringify(value), secretKey).toString();
          window.sessionStorage.setItem(key, setEncryptedData);
        },
        get: function (key) {
          let getEncryptedData = window.sessionStorage.getItem(key);
          if (!_.isNull(getEncryptedData))
            return JSON.parse(CryptoJS.AES.decrypt(getEncryptedData, secretKey).toString(CryptoJS.enc.Utf8))
          return null;
        },
        remove: function (key) {
          window.sessionStorage.removeItem(key);
        }
      }
    }
  },
  methods: {
    showLoading: function () {
      this.LOADING = this.$loading.show({
        color: PROJECT == 'ticketak' ? '#e0007c' : '#0c133d',
        // color: '#AD2318',

        loader: 'spinner',
        width: 105,
        height: 105,
        class: 'css-loader',
        backgroundColor: 'rgba(0, 0, 0, 0.5);',
        opacity: 0.5,
        zIndex: 99999,
      })
      document.body.classList.add('modal-open')
      this.data_loading = true;
    },

    hideLoading: function () {
      this.LOADING ? this.LOADING.hide() : "";
      document.body.classList.remove('modal-open');
      this.data_loading = false
    },

  }
})
/* eslint-disable no-new */
initi18n().then(i18n => {
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  created () {
    AOS.init();
},
  mounted() {
    // if (PROJECT === 'myticketi' && !country && this.$route.name !== 'Home') {
    //   this.$root.$emit("bv::show::modal", "countryModalRef");
    // }
  }
})
});



// WEBPACK FOOTER //
// ./src/main.js